import API from "@/api/modules/docs";
import { resultErrorOf, resultErrorMessage } from "@/api/helpers/resultError";

const state = () => ({
  docs: [],
  doc: null,
  // lang => body html
  docTexts: {},
  // why the last save was refused, straight from the service
  saveError: "",
});

export default {
  namespaced: true,
  state,
  mutations: {
    SET_DATA(state, { type, data }) {
      state[type] = data;
    },
    SET_DOC_TEXT(state, { lang, text }) {
      state.docTexts = { ...state.docTexts, [lang]: text };
    },
  },
  actions: {
    getDocs({ commit }) {
      return API.getDocs().then((response) => {
        if (response && response.data) {
          commit("SET_DATA", { type: "docs", data: response.data.docs || [] });
        }
      });
    },

    /**
     * A page listed from the legacy table may not exist in Postgres yet, and the service answers
     * that with an error rather than a document. That is an expected state for an untouched page,
     * not a failure, so the doc is left null and the caller falls back to the legacy row.
     */
    getDoc({ commit }, docId) {
      return API.getDoc(docId).then((response) => {
        const doc = response && response.data && response.data.doc;
        commit("SET_DATA", { type: "doc", data: doc || null });

        return doc || null;
      });
    },

    getDocTexts({ commit }, docId) {
      return API.getDocTexts(docId).then((response) => {
        const texts = (response && response.data && response.data.texts) || [];

        const byLang = {};
        texts.forEach((item) => {
          if (item.alias === API.BODY_ALIAS) {
            byLang[item.lang] = item.text || "";
          }
        });

        commit("SET_DATA", { type: "docTexts", data: byLang });

        return byLang;
      });
    },

    upsertDoc({ commit }, payload) {
      commit("SET_DATA", { type: "saveError", data: "" });

      return API.upsertDoc(payload).then((response) => {
        // A refusal arrives as HTTP 200 with an error body, so the reason has to be read out of it
        // rather than caught.
        const error = resultErrorOf(response);
        if (error) {
          commit("SET_DATA", { type: "saveError", data: resultErrorMessage(error) });

          return null;
        }

        const doc = response && response.data && response.data.doc;
        if (doc) {
          commit("SET_DATA", { type: "doc", data: doc });
        }

        return doc || null;
      });
    },

    saveDocText({ commit }, payload) {
      return API.saveDocText(payload).then((response) => {
        commit("SET_DOC_TEXT", { lang: payload.lang, text: payload.text });

        return response;
      });
    },

    clearDoc({ commit }) {
      commit("SET_DATA", { type: "doc", data: null });
      commit("SET_DATA", { type: "docTexts", data: {} });
      commit("SET_DATA", { type: "saveError", data: "" });
    },
  },
};
